<template>
	<div class="measurementTracker">
		<AppHeader></AppHeader>
		<div class="page-wrapper">
			<div class="container-fluid">
				<!-- Title -->
				<div class="row heading-bg text-center" style="margin-bottom:-10px;">
					<div class="col-lg-12 col-md-4 col-sm-4 col-xs-12">
						<h5 class="txt-dark">My Profile</h5>
					</div>
				</div>
				<div class="col-md-12">
					<div class="col-md-12">
						<div class="form-group col-md-6">
							<label for="">Name</label>
							<input class="form-control" type="text" v-model="me.name">
						</div>
						<div class="form-group col-md-6">
							<label for="">Email</label>
							<input class="form-control" type="text" v-model="me.email">
						</div>
						<div class="form-group col-md-6">
							<label for="">Gender</label>
							<select name="" id="" class="form-control" v-model="me.meta_data.gender">
								<option value="female">Female</option>
								<option value="male">Male</option>
							</select>
						</div>
						<div class="form-group col-md-6">
							<label for="">Activity Level</label>
							<select name="" id="" class="form-control" v-model="me.meta_data.activity_level">
								<option value="1">Sitting - I don't move around as much as I'd like. I'm at my desk most of my day with maybe some walking around.</option>
								<option value="2">On my feet - I spend much of the day on my feet working, doing things like heavy cleaning or waiting tables.</option>								
								<option value="3">Hustling - I have a physically active job and am active most of the time.</option>								
							</select>
						</div>
						<div class="form-group col-md-6">
							<label for="">Exercise Level</label>
							<select name="" id="" class="form-control" v-model="me.meta_data.exercise_level">
								<option value="1">Light to no exercise</option>
								<option value="1.375">Light exercise 1-3 days per week</option>								
								<option value="1.55">Moderate exercise 3-5 days per week</option>								
								<option value="1.725">Hard exercise 6-7 days per week</option>
								<option value="1.9">Very intense exercise</option>
							</select>
						</div>
						<div class="form-group col-md-6">
							<label for="">Recommended Intake Calculation</label>
							<select name="" id="" class="form-control" v-model="me.meta_data.recommended_intake_calculation">
								<option value="standard">Standard</option>
								<option value="keto">Keto</option>
								<option value="menopause" v-if="me.meta_data.gender == 'female'">Menopause</option>
							</select>
						</div>
						<div class="form-group col-md-6">
							<label for="">Date of Birth</label>
							<datepicker input-class="form-control" v-model="me.meta_data.date_of_birth"></datepicker>
							<!-- <datetime v-model="me.meta_data.date_of_birth" input-id="startDate" format="dd/MM/yyyy">
								<template slot="button-cancel">
									<fa :icon="['far', 'times']"></fa>
									Cancel
								</template>
								<template slot="button-confirm">
									<fa :icon="['fas', 'check-circle']"></fa>
									Confirm
								</template>
							</datetime> -->
						</div>
						<div class="form-group col-md-6">
							<label for="">Preferred Unit of Measure</label>
							<select name="" id="" class="form-control" v-model="me.meta_data.preferred_units" @change="changeHeightValue" ref="units_select">
								<option value="imperial">Imperial</option>
								<option value="metric">Metric</option>
							</select>
						</div>
						<div class="form-group col-md-6">
							<label for="">Height</label>
							<div class="input-group col-sm-12">
									<input type="number" class="form-control" id="name" placeholder="Height" v-model="height"> 
									<span class="input-group-addon">{{height_units == "metric" ? "cm" : "in"}}</span>
							</div>
						</div>
						<div class="form-group col-md-6">
							<label for="">Weight</label>
							<div class="input-group col-sm-12">
								<input type="number" class="form-control" id="name" placeholder="Weight" v-model="me.weight"> 
							</div>
						</div>
						<div class="form-group col-md-6">
							<label for="">Goal Weight</label>
							<div class="input-group col-sm-12">
								<input type="number" class="form-control" id="name" placeholder="Weight" v-model="me.meta_data.goal_weight"> 
							</div>
						</div>
						<div class="form-group col-md-6">
							<label for="">Diet Goals</label>
							<select name="" id="" class="form-control" v-model="me.meta_data.diet_goal">
								<option value="weightloss">Weight Loss</option>
								<option value="eatbalanced">Eat Balanced</option>
								<option value="buildmuscle">Build Muscle</option>
							</select>
						</div>
						<div class="form-group col-md-6">
							<label for="">Body Type</label>
							<select name="" id="" class="form-control" v-model="me.meta_data.body_type">
								<option value="slim">Slim</option>
								<option value="normal">Normal</option>
								<option value="stocky">Stocky</option>
							</select>
						</div>
						<div class="form-group col-md-6">
							<label for="" class="mb-10">Membership Type: </label><br/>
							<span style="font-weight:bold; text-transform:capitalize;">
								{{me.vip_user ? 'VIP' : 'Free'}} 
								<span v-if="me.vip_user">(Renews every {{me.subscription_renews_every}})</span>
							</span>
						</div>
						<div class="form-group col-md-12 mt-10" style="margin-bottom:-20px;text-align:center;">
							<label>Where is most of the fat stored in your body?</label>
							<div class="form-group col-md-12">
								<div class="col-sm-6 col-sm-offset-3 body_fat_stored_images">
									<img class="col-md-2" src="dist/img/bfd1.png" alt="" :class="me.meta_data.body_fat_distribution == 1 ? 'bfd-chosen' : ''" @click="me.meta_data.body_fat_distribution = 1">
									<img class="col-md-2" src="dist/img/bfd2.png" alt="" :class="me.meta_data.body_fat_distribution == 2 ? 'bfd-chosen' : ''" @click="me.meta_data.body_fat_distribution = 2">
									<img class="col-md-2" src="dist/img/bfd3.png" alt="" :class="me.meta_data.body_fat_distribution == 3 ? 'bfd-chosen' : ''" @click="me.meta_data.body_fat_distribution = 3">
									<img class="col-md-2" src="dist/img/bfd4.png" alt="" :class="me.meta_data.body_fat_distribution == 4 ? 'bfd-chosen' : ''" @click="me.meta_data.body_fat_distribution = 4">
									<img class="col-md-2" src="dist/img/bfd5.png" alt="" :class="me.meta_data.body_fat_distribution == 5 ? 'bfd-chosen' : ''" @click="me.meta_data.body_fat_distribution = 5">
									<img class="col-md-2" src="dist/img/bfd6.png" alt="" :class="me.meta_data.body_fat_distribution == 6 ? 'bfd-chosen' : ''" @click="me.meta_data.body_fat_distribution = 6">
								</div>
							</div>
						</div>
						<div class="form-group col-md-12 mt-20">
							<a href="#" @click="updateAccount" class="btn btn-nutri-green full-width">Update Details</a>
						</div>
						<div class="form-group col-md-12">
							<router-link v-if="!me.vip_user" to="/profile/upgrade" class="btn full-width upgrade-btn">
								<span>Upgrade To Premium</span>
							</router-link>
						</div>
					</div>
				</div>				
			</div>
			<!-- /Main Content -->
			<AppFooter></AppFooter>
		</div>
	</div>
</template>

<script>

import API from '../../services/api.js';
import AppHeader from '../../components/common/AppHeader.vue'
import AppFooter from '../../components/common/AppFooter.vue'
import Datepicker from 'vuejs-datepicker'
import swal from 'sweetalert'
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

import {
	mapMutations
} from 'vuex';
const api = new API();

export default {
	data() {
		return {
			me: this.$store.getters.user,
			height: this.$store.getters.user.meta_data.preferred_units == 'imperial' ? this.$store.getters.user.height_imperial : this.$store.getters.user.meta_data.height,
			height_units:null
		}
        },
        components:{
                AppHeader,
		AppFooter,
		Datepicker,
		swal,
		Datetime
        },
	created() {
		this.height_units = this.me.meta_data.preferred_units;
	},
	methods: {
		updateAccount(){
			let profile = {
				"name": this.me.name,
				"date_of_birth": this.me.meta_data.date_of_birth,
				"gender" : this.me.meta_data.gender,
				"height" : this.height,
				"preferred_units" : this.me.meta_data.preferred_units,
				"email" : this.me.email,
				"recommended_intake_calculation" : this.me.meta_data.recommended_intake_calculation,
				"exercise_level": this.me.meta_data.exercise_level,
				"activity_level": this.me.meta_data.activity_level,
				"weight": this.me.weight,
				"diet_goal": this.me.meta_data.diet_goal,
				"body_type": this.me.meta_data.body_type,
				"body_fat_distribution": this.me.meta_data.body_fat_distribution

			};
			api.updateProfile(profile).then(async response =>{
                                if(response.data.success){
					swal("Account Updated!", "Your account details have been updated.", "success");
					api.me();
					setTimeout(() => {
						swal.close();
					}, 4000);
                                }
                        });
		},
		changeHeightValue(){
			let new_unit = this.$refs.units_select.value;
			this.height_units = new_unit;
			if(new_unit == "metric"){
				this.height = (this.height / 0.393701).toFixed(0);
			}else{
				this.height = (this.height * 0.393701).toFixed(0);
			}
		}
	}
}
</script>

<style scoped>
.upgrade-btn:hover{
	background-color: #d28d07;
	border: 2px solid #d28d07 !important;
  	color: #fff !important;
  	border-radius: 5px !important;
}

.upgrade-btn{
	background-color: #F8B32A;
	border: 2px solid #d28d07 !important;
  	color: #fff !important;
  	border-radius: 5px !important;
}

.btn{
	border-radius: 3px;
}

.body_fat_stored_images{
	margin-top:50px;
	margin-bottom: 50px;
}

.bfd-chosen{
	-webkit-filter: grayscale(0%) !important; /* Safari 6.0 - 9.0 */
	filter: grayscale(0%) !important;
}

.body_fat_stored_images img {
	-webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
	filter: grayscale(100%);
	cursor: pointer;
}

.body_fat_stored_images img:hover{
	-webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
	filter: grayscale(0%);
}
</style>


// WEBPACK FOOTER //
// src/views/Profile/Profile.vue